import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { UserModel } from '@/features/login-and-signup/types/user-model';
import { storage } from '../../libs';

export interface UserAuthModel extends UserModel {
  token: string;
}

export type AuthState = {
  user: UserAuthModel | UserModel | null;
};

const initState: AuthState = {
  user: storage.user.get() ?? null,
};

export const useAuth = createStore({
  name: 'user-auth-state',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setUser: handler('user', u => storage.user.set(u)),
  };
});
